import { Grid, TextField } from "@mui/material";
import type { Control, UseFormRegister, UseFormWatch } from "react-hook-form";
import ExhibitorSelectFieldList from "src/common/ExhibitorSelectFieldList";
import SelectAccountListByMethod from "src/common/SelectAccountListByMethod";
import InvoiceExhibitorSelectFieldList from "src/content/modules/exhibitor/common/InvoiceExhibitorSelectFieldList";
import type { SingleExhibitorInvoiceInfo } from "../type/exhibitorType";

type IProps = {
	register: UseFormRegister<any>;
	watch: UseFormWatch<any>;
	control?: Control<any, any>;
	invoiceDetails?: SingleExhibitorInvoiceInfo;
};
const MoneyReceiptForm = ({
	watch,
	control,
	register,
	invoiceDetails,
}: IProps) => {
	return (
		<Grid container spacing={2}>
			{invoiceDetails?.user_fair_member_company_name ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={invoiceDetails?.user_fair_member_company_name}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<ExhibitorSelectFieldList
						mt='0'
						fieldName='exhibitor_id'
						register={register}
						isRequired
						hideCustomLabel
					/>
				</Grid>
			)}

			{invoiceDetails?.invoice_no ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={invoiceDetails?.invoice_no}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<InvoiceExhibitorSelectFieldList
						mt='0'
						fieldName='invoice_id'
						register={register}
						isRequired
						hideCustomLabel
						watch={watch}
					/>
				</Grid>
			)}

			<SelectAccountListByMethod
				register={register}
				md={12}
				lg={6}
				watch={watch}
				control={control}
			/>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Payment Date'
					type='date'
					InputLabelProps={{ shrink: true }}
					{...register("payment_date", {
						required: {
							value: true,
							message: "Please, Provide an account name!",
						},
					})}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Discount'
					type='number'
					{...register("discount")}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Amount'
					type='number'
					defaultValue={invoiceDetails?.due}
					{...register("amount")}
				/>
			</Grid>

			{/* <Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						label='Bank Name'
						{...register("bank_name")}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						label='Cheque No'
						{...register("cheque_no")}
					/>
				</Grid> */}

			<Grid item xs={12}>
				<TextField
					fullWidth
					label='Note'
					multiline
					rows={4}
					placeholder='Write additional details (optional)...'
					{...register("note")}
				/>
			</Grid>
		</Grid>
	);
};

export default MoneyReceiptForm;
